export const UPDATE_STATE = 'UPDATE_STATE';

export const UPDATE_NAME = 'UPDATE_NAME';
export const UPDATE_EMAIL = 'UPDATE_EMAIL';
export const UPDATE_PHONE = 'UPDATE_PHONE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
